import { InterestRateTypes, rateConversion } from './rateConversion';

export const getIRateTypeLabel = (type: InterestRateTypes) => (type === 'm' ? 'M.V.' : 'E.A.');

const preFormatIRate = (value: any) => {
  if (typeof value === 'number') return `${parseFloat((value * 100).toFixed(2))}`;
  return '';
};

export const formatIRate = (monthlyValue: any, type?: InterestRateTypes) => {
  if (type && typeof monthlyValue === 'number') return `${preFormatIRate(rateConversion(monthlyValue, 'm', type))} % ${getIRateTypeLabel(type)}`;
  return preFormatIRate(monthlyValue);
};
